import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_OPTIMIZELY_PROPERTY_SAFELIST = createFcmDetails('optimizely_property_safelist', {
	owner: 'Site-Platform',
	context: 'front-end (optimizely)',
	description: `
When the front-end sends a tracking event to optimizely (see optimizely_event_safelist), the properties sent alongside the optimizely event are filtered by this safe list.

Related FCM: optimizely_property_safelist
	`,
	template: ['amount'],
	import: false,
});
